import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Specification'

  }
];

@Component({
  selector: 'page-product-standard',
  templateUrl: './product-standard.html',
  styleUrls: ['./product-standard.scss']
})

export class PageProductStandard implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any="";
  products = [];
  //autoincreate
  filtered:any;
  ctrl:FormControl;
  items = [];
  //form
  form: FormGroup;selectedCtrl = new FormControl();
  selected:any;
  name:string;limit:string;uncertainty:string;status:string;id:string;
  ckedit:boolean=false;
  //upload
  fileupload:string;
  //data table
  data:any;
  rows = [];temp=[];
  //upload file
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  Name:string; 
  myFile:File; /* property of File type */

  //dialog
  dialogRefWarning: MdDialogRef<WarningProductStandardDialog>;
  dialogRef: MdDialogRef<productStandardDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/spec-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/spec-list-export.php";
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.getSearchProductStandard();
    this.getStartData();
    this._sharedService.emitChange(this.pageTitle);
  }

  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
        clearInterval(this.setId);
        }
      this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);

  }

  getStartData(){
    this.httpservice.fetchget('getJSON_product_standard.php?',(product) => {
      this.rows = product;
      this.temp = product;
      this.loadingIndicator = false;
      console.log('------this.machine------', this.key,product,this.rows);
    });
  }
  getSearchProductStandard(){
    this.httpservice.fetchget('getJSON_product_standard_name.php?',(product) => {
      this.products = product.map(function (val) {
        return [val.tb87f_name];
      });
      console.log('------this.machine------', this.products);
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.products.filter((s) => new RegExp(val, 'gi').test(s)) : this.products;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteProductStandard.php', val, (cb) => {});
  this.setId = this.intervalGetData();
  }

  setedit(id:string){
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_product_standard.php?id='+id,(product) => {
      this.form.controls.name.setValue(product[0].tb87f_name);
      this.form.controls.limit.setValue(product[0].tb87f_limit);
      this.form.controls.uncertainty_low.setValue(product[0].tb87f_uncertainty_low);
      this.form.controls.uncertainty_high.setValue(product[0].tb87f_uncertainty_high);
    });
  }

  edit(){
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }

    this.ckedit = false;
    this.data = {
      id:this.id,
      name:this.form.controls.name.value,
      limit:this.form.controls.limit.value,
      uncertainty_high:this.form.controls.uncertainty_high.value,
      uncertainty_low:this.form.controls.uncertainty_low.value,
      filename:this.fileupload
    }
    // insert data
    this.httpservice.fetchpost('editDataProductStandard.php', this.data, (cb) => {});

      //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }

    this.setId = this.intervalGetData();
    this.form.reset();
  }

  cancelEdit(){
    this.ckedit = false;
    this.form.reset();
  }


save(){

  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }


  this.data = {
    id:this.id,
    name:this.form.controls.name.value,
    limit:this.form.controls.limit.value,
    uncertainty_high:this.form.controls.uncertainty_high.value,
    uncertainty_low:this.form.controls.uncertainty_low.value,
    filename:this.fileupload
  }
  // insert data
  this.httpservice.fetchpost('insertDataProductStandard.php', this.data, (cb) => {});
  this.setId = this.intervalGetData();
  //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
  this.form.reset();
  this.selectedCtrl.reset();
}

search(){ 
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_product_standard.php?key='+this.key,(product) => {
    this.rows = product;
  });
  this.ctrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      limit: [null, Validators.compose([Validators.required])],
      uncertainty_high: [null, Validators.compose([Validators.required])],
      uncertainty_low: [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }


    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb87f_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }

  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(productStandardDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(productStandardDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.limit.value!=null && this.form.controls.name.value){
          this.edit();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value !');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(productStandardDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value && this.form.controls.limit.value !=""){
          this.save();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value!');
        }
      
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningProductStandardDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'product-standard-dialog',
  templateUrl: 'dialog.html',
})
export class productStandardDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<productStandardDialog>) {}
}

//warning
@Component({
  selector: 'warning-product-standard-dialog',
  templateUrl: 'warning.html',
})
export class WarningProductStandardDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningProductStandardDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/control-chart-setting/product-standard.ts